import { Component, OnInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { IFacilityData } from "../../interfaces/administration/facilityData";
import { FacilityService } from "../../services/administration/facilities/facilities.service";
import { ActivatedRoute, Router } from "@angular/router";
import { BaseComponent } from "../../shared/base/base.component";
import { LoggedUserService } from "../../services/common/logged-user.service";

@Component({
  selector: "facilities-component",
  templateUrl: "./facilities.component.html",
})
export class FacilitiesComponent extends BaseComponent implements OnInit {
  title = "Facilities";
  isLoading = true;
  displayedColumns: string[] = ["id", "name", "entraName", "actions"];
  facilitiesData = new MatTableDataSource<IFacilityData>();

  constructor(
    private service: FacilityService,
    private router: Router,
    loggedUserService: LoggedUserService,
    route: ActivatedRoute
  ) {
    super(loggedUserService, route);
  }

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  ngOnInit(): void {
    this.loadFacilities();
  }

  loadFacilities() {
    this.isLoading = true;
    this.service.getFacilities().subscribe((data) => {
      this.facilitiesData = new MatTableDataSource(data);
      this.isLoading = false;
      this.facilitiesData.paginator = this.paginator;
      this.facilitiesData.sort = this.sort;
    });
  }

  confirmDeleteFacility(data: IFacilityData) {
    if (window.confirm("Are you sure you want to delete this facility?")) {
      this.service.deteleFacility(data.id).subscribe((result) => {
        this.loadFacilities();
      });
    }
  }

  editFacility(data: IFacilityData) {
    this.router.navigate(["/administration/facilities/edit/" + data.id]);
  }

  addFacility() {
    this.router.navigate(["/administration/facilities/create"]);
  }
}
